import * as fs from 'node:fs';
import { OpenAPIObject } from 'openapi3-ts/oas31';
import {
  FormGenerator,
  EndPointsGenerator,
  BarrelGenerator,
  FormGroupFactoryGenerator,
  ModelGenerator,
  ModelPropertiesGenerator,
  EnumGenerator,
  TestObjectFactoryGenerator,
} from './generators/index.ts';
import { IGeneratorOptions, setGeneratorOptionDefaults } from './models/generator-options.ts';
import { ITemplateData } from './models/template-data.ts';
import { OpenApiDocConverter } from './openapidoc-converter.ts';
import Axios from 'axios';

export { nrsrxTypeFilterCallBack, nrsrxValuePropertyTypeFilterCallBack } from './models/nrsrx-filters.ts';

export async function generateTsModels(options: IGeneratorOptions): Promise<void> {
  options = setGeneratorOptionDefaults(options);
  const apiDocument: OpenAPIObject = await getOpenApiDocumentAsync(options);
  const converter = new OpenApiDocConverter(options, apiDocument);
  const templateData: ITemplateData = converter.convertDocument();
  generateOutput(options, templateData);
}

async function getOpenApiDocumentAsync(options: IGeneratorOptions): Promise<OpenAPIObject> {
  let apiDoc: OpenAPIObject;
  if (options.openApiJsonUrl) {
    const response = await Axios.get(options.openApiJsonUrl, options.axiosConfig);
    apiDoc = response.data as OpenAPIObject;
  } else if (options.openApiJsonFileName) {
    const response = fs.readFileSync(`${__dirname}/${options.openApiJsonFileName}`);
    apiDoc = JSON.parse(response.toString()) as OpenAPIObject;
  } else {
    throw new Error(
      'You must specify either an OpenApi Json Url or FileName.  Please review the readme.md @ https://github.com/ikemtz/openapi-ts-generator.',
    );
  }
  return apiDoc;
}

function generateOutput(options: IGeneratorOptions, templateData: ITemplateData) {
  if (fs.existsSync(options.outputPath)) {
    fs.readdirSync(options.outputPath).forEach((file) => {
      fs.unlinkSync(`${options.outputPath}/${file}`);
    });
    fs.rmSync(options.outputPath, { recursive: true });
  }
  fs.mkdirSync(options.outputPath, { recursive: true });
  const modelGenerator = new ModelGenerator(options);
  modelGenerator.generate(templateData);

  if (options.genAngularFormGroups) {
    const formGroupGenerator = new FormGroupFactoryGenerator(options);
    formGroupGenerator.generate(templateData);
    const formGenerator = new FormGenerator(options);
    formGenerator.generate(templateData);
  }

  const modelPropertiesGenerator = new ModelPropertiesGenerator(options);
  modelPropertiesGenerator.generate(templateData);
  const endpointGenerator = new EndPointsGenerator(options);
  endpointGenerator.generate(templateData);
  const barrelGenerator = new BarrelGenerator(options);
  const enumGenerator = new EnumGenerator(options);
  enumGenerator.generate(templateData);
  const testObjFacGenerator = new TestObjectFactoryGenerator(options);
  testObjFacGenerator.generate(templateData);
  barrelGenerator.generate();
}
